import type { SVGProps } from 'react';

const SvgFoldRightLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M16 17L20 12L16 7' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M10 12L20 12' stroke='currentColor' strokeMiterlimit={10} strokeLinecap='round' />
    <path d='M4 19L4 5' stroke='currentColor' strokeMiterlimit={10} strokeLinecap='round' />
  </svg>
);
export default SvgFoldRightLt;
